import React, { useEffect, useState } from 'react';
import { Alert, Card, Table } from 'react-bootstrap';
import UserLayout from '../../components/user/UserLayout';
import api from '../../lib/api';
import { useToast } from '../../components/common/ToastProvider';

const getError = (e, fallback) =>
  e?.response?.data?.error ||
  e?.response?.data?.detail ||
  e?.message ||
  fallback;

export default function UserSettingsPage() {
  const [workspace, setWorkspace] = useState(null);
  const [auditRows, setAuditRows] = useState([]);
  const [msg, setMsg] = useState('');
  const { showToast } = useToast();

  const load = async () => {
    try {
      const [wsRes, auditRes] = await Promise.all([
        api.get('/user/settings/workspace/'),
        api.get('/user/settings/audit-logs/', { params: { page_size: 30 } }),
      ]);
      setWorkspace(wsRes.data || null);
      setAuditRows(auditRes.data?.results || []);
      setMsg('');
    } catch (e) {
      const errorMessage = getError(e, 'Unable to load workspace audit logs.');
      setMsg(errorMessage);
      showToast(errorMessage, 'danger');
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <UserLayout
      title="Workspace Settings"
      subtitle="Audit trail for your own workspace activity."
    >
      {msg ? <Alert variant="danger">{msg}</Alert> : null}

      <Card className="user-card p-4 mb-4">
        <div className="user-section-title">Workspace</div>
        <div className="text-muted small">
          Name: <strong>{workspace?.name || '—'}</strong> · Slug: <strong>{workspace?.slug || '—'}</strong>
        </div>
      </Card>

      <Card className="user-card p-4">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="user-section-title mb-0">Recent Audit Logs</div>
        </div>
        <div className="table-responsive">
          <Table hover>
            <thead>
              <tr>
                <th>When</th>
                <th>Action</th>
                <th>Category</th>
                <th>Actor</th>
              </tr>
            </thead>
            <tbody>
              {auditRows.map((row) => (
                <tr key={row.id}>
                  <td>{row.created_at ? new Date(row.created_at).toLocaleString() : '—'}</td>
                  <td>{row.action || '—'}</td>
                  <td>{row.category || '—'}</td>
                  <td>{row.actor_username || row.actor_email || 'system'}</td>
                </tr>
              ))}
              {!auditRows.length ? (
                <tr>
                  <td colSpan={4} className="text-center text-muted py-4">
                    No audit events yet for this workspace.
                  </td>
                </tr>
              ) : null}
            </tbody>
          </Table>
        </div>
      </Card>
    </UserLayout>
  );
}
